import { useState } from 'react';

const testimonials = [
  {
    name: 'Jocelyn Harvey',
    text: 'So very thankful for Rick and his quick response time! Our AC unit stopped working Friday at 9pm, & we have been in the 90s, some days 100s. Rick was out the next day and had us back cool in no time. He is skilled, efficient and ready to handle your concerns! AirTek will always be the one we call for our HVAC needs!',
    rating: 5,
    source: 'Google',
  },
  {
    name: "Kevin O'Grady",
    text: 'Great experience with this company .. performed a new install for me which exceeded my expectations .. I\'d recommend this company to any one!!',
    rating: 5,
    source: 'Google',
  },
  {
    name: 'Ed Wilcox',
    text: 'AIR-TEK is honest and reliable. Responded quickly to my call. Was very professional! Thanks again!',
    rating: 5,
    source: 'Google',
  },
  {
    name: 'Phil Edmondson',
    text: "Found prices reasonable. Very professional, responded quickly, couldn't ask for better service. Thank you AIR-TEK!",
    rating: 5,
    source: 'Google',
  },
  {
    name: 'Ian C.',
    text: "Instead of waiting to fix our AC after the hurricane, Ricky went above and beyond (on a last minute work order) to make sure our family didn't have to go without AC. Ricky and Air-Tek literally saved the day and we will be forever grateful. The guys at Air-Tek are extremely prompt, kind and professional. I am completely blown away by their incredible services.",
    rating: 5,
    source: 'Google',
  },
  {
    name: 'Heather Boyd',
    text: 'Superb and dependable service at a very reasonable cost!! Air-Tek My 1st and only call everytime!!',
    rating: 5,
    source: 'Google',
  },
];

export default function Testimonials() {
  const [activeIdx, setActiveIdx] = useState(0);

  const prev = () => setActiveIdx((i) => (i === 0 ? testimonials.length - 3 : i - 1));
  const next = () => setActiveIdx((i) => (i >= testimonials.length - 3 ? 0 : i + 1));

  const visible = [
    testimonials[activeIdx % testimonials.length],
    testimonials[(activeIdx + 1) % testimonials.length],
    testimonials[(activeIdx + 2) % testimonials.length],
  ];

  return (
    <section id="testimonials" className="bg-[#0f1923] py-24">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        {/* Top image strip */}
        <div className="relative w-full h-52 rounded-2xl overflow-hidden mb-14">
          <img
            src="https://public.readdy.ai/ai/img_res/9108925375bc40addde32ed46a662bd0.jpg"
            alt="Happy Air-Tek NC customers"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-[#0f1923]/90 via-[#0f1923]/60 to-transparent" />
          <div className="absolute inset-0 flex items-center px-10 md:px-16">
            <div>
              <span className="text-[#00d4ff] text-xs font-bold tracking-widest uppercase">Real Google Reviews</span>
              <h2
                className="text-3xl md:text-4xl font-bold text-white mt-2"
                style={{ fontFamily: 'Outfit, sans-serif' }}
              >
                What Clients Are Saying
              </h2>
              <div className="flex items-center gap-1.5 mt-2">
                {[...Array(5)].map((_, i) => (
                  <div key={i} className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-star-fill text-yellow-400 text-sm" />
                  </div>
                ))}
                <span className="text-[#9ca3af] text-sm ml-1">5.0 — Rated on Google</span>
              </div>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-10">
          {visible.map((t, idx) => (
            <div
              key={idx}
              className={`bg-[#1a2535] rounded-2xl p-7 border transition-all duration-300 flex flex-col ${idx === 0 ? 'border-[#00d4ff]/30' : 'border-white/5'}`}
            >
              <div className="flex items-center justify-between mb-5">
                <div className="flex gap-1">
                  {[...Array(t.rating)].map((_, i) => (
                    <div key={i} className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-star-fill text-yellow-400 text-sm" />
                    </div>
                  ))}
                </div>
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-google-fill text-[#9ca3af] text-lg" />
                </div>
              </div>

              <div className="w-8 h-8 flex items-center justify-center mb-3">
                <i className="ri-double-quotes-l text-[#00d4ff] text-3xl opacity-50" />
              </div>

              <p className="text-[#d1d5db] text-sm leading-relaxed flex-1 mb-5">{t.text}</p>

              <div className="border-t border-white/5 pt-4">
                <p className="text-white font-semibold text-sm">{t.name}</p>
                <p className="text-[#6b7280] text-xs mt-0.5">Verified Google Review</p>
              </div>
            </div>
          ))}
        </div>

        {/* Navigation */}
        <div className="flex items-center justify-center gap-4">
          <button
            onClick={prev}
            className="w-10 h-10 flex items-center justify-center rounded-full border border-white/20 text-white hover:border-[#00d4ff] hover:text-[#00d4ff] transition-all duration-200 cursor-pointer"
            aria-label="Previous"
          >
            <i className="ri-arrow-left-line" />
          </button>
          <div className="flex gap-2">
            {testimonials.slice(0, testimonials.length - 2).map((_, i) => (
              <button
                key={i}
                onClick={() => setActiveIdx(i)}
                className={`h-1.5 rounded-full transition-all duration-200 cursor-pointer ${i === activeIdx ? 'w-6 bg-[#00d4ff]' : 'w-1.5 bg-white/20'}`}
                aria-label={`Go to review ${i + 1}`}
              />
            ))}
          </div>
          <button
            onClick={next}
            className="w-10 h-10 flex items-center justify-center rounded-full border border-white/20 text-white hover:border-[#00d4ff] hover:text-[#00d4ff] transition-all duration-200 cursor-pointer"
            aria-label="Next"
          >
            <i className="ri-arrow-right-line" />
          </button>
        </div>
      </div>
    </section>
  );
}
